import LocationSearchInput from './LocationSearchInput';

export default LocationSearchInput;
